const darTimeoutOptions = {
  notSet: {
    value: "unset",
    label: "Not Set",
  },
  manual: {
    value: "manual",
    label: "Manual",
  },
  zeroSeconds: {
    value: "0",
    label: "0 seconds",
  },
  fiveSeconds: {
    value: "5",
    label: "5 seconds",
  },
  tenSeconds: {
    value: "10",
    label: "10 seconds",
  },
  twentySeconds: {
    value: "20",
    label: "20 seconds",
  },
  twentyFiveSeconds: {
    value: "25",
    label: "25 seconds",
  },
  thirtySeconds: {
    value: "30",
    label: "30 seconds",
  },
  fortySeconds: {
    value: "40",
    label: "40 seconds",
  },
  fiftySeconds: {
    value: "50",
    label: "50 seconds",
  },
  oneMinute: {
    value: "60",
    label: "1 minute",
  },
  twoMinutes: {
    value: "120",
    label: "2 minutes",
  },
  threeMinutes: {
    value: "180",
    label: "3 minutes",
  },
  fourMinutes: {
    value: "240",
    label: "4 minutes",
  },
  fiveMinutes: {
    value: "300",
    label: "5 minutes",
  },
  tenMinutes: {
    value: "600",
    label: "10 minutes",
  },
  fifteenMinutes: {
    value: "900",
    label: "15 minutes",
  },
  thirtyMinutes: {
    value: "1800",
    label: "30 minutes",
  },
  fortyFiveMinutes: {
    value: "2700",
    label: "45 minutes",
  },
  sixtyMinutes: {
    value: "3600",
    label: "60 minutes",
  },
};

export default darTimeoutOptions;
export const darTimeoutOptionsList = Object.values(darTimeoutOptions);
